import { ChangeDetectionStrategy, Component, model, ViewEncapsulation } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslatePipe } from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';
@Component({
  selector: 'app-phx-message',
  imports: [
    MessageModule,
    TranslatePipe
  ],
  templateUrl: './phx-message.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhxMessageComponent extends FieldType {
  /** The message to display. If not set, the content of the component will be displayed. */
  message = model<string>(null);
  /** The severity of the message. */
  severity = model<"success" | "info" | "warn" | "secondary" | "contrast" | "error">("info");
  /** The variant of the message. */
  variant = model<"text" | "outlined" | "simple">(null);
  /** Whether the message can be closed manually using the close icon. */
  closable = model<boolean>(false);
  /** The time in milliseconds that the message will be displayed. */
  life = model<number>(undefined);
  /** The icon to display in the message. */
  icon = model<string>(undefined);
  /** The icon to display in the close button. */
  closeIcon = model<string>(undefined);
  /** The size of the message. (default = medium = null) */
  size = model<"small" | null | "large">(null);
  /** Whether the message should be translated. */
  translate = model<boolean>(false);
}
